import React from 'react';
import ProjectTransitionFields from './ProjectTransitionFields';
import { projectTransitionSchema } from '../../../lib/project-transition-schemas';

export default function ApprovedForm({ values, onChange, errors }) {
  return <ProjectTransitionFields schema={projectTransitionSchema('approved')} values={values} onChange={onChange} errors={errors} />;
}
